import Mock from 'mockjs'


// 获取用户登录信息
export function tablemetalist() {
    return {
        isOpen: true,
        url: '/customform/tablemeta/list',
        type: 'post',
        data: {
            pageIndex: 1,
            pageSize: 15,
            rows: [{
                "createTime": "2019-08-26 15:22:00",
                "id": "bdfa8d9b63544a3eb542a2393f594604",
                "displayName": "其他交易公告信息",
                "datasetCode": "Q01",
                "sort": 18,
                "status": 0,
                "tableName": "qtjy_other_trade_pub_info",
                "uniqueNames": "其他交易公告唯一标识",
                "updateTime": "2019-09-18 16:41:59",
                "updateUser": "0"
            }, {
                "createTime": "2019-08-26 15:22:00",
                "id": "bdfa8d9b63544a3eb542a2393f594604",
                "displayName": "其他交易公告信息",
                "datasetCode": "Q01",
                "sort": 18,
                "status": 0,
                "tableName": "qtjy_other_trade_pub_info",
                "uniqueNames": "其他交易公告唯一标识",
                "updateTime": "2019-09-18 16:41:59",
                "updateUser": "0"
            }, ],
            total: 2,
            totalItemCount: 2,
            totalPageCount: 1
        }
    }
}


export function savetablemetaData() {
    return {
        //isOpen: false,
        url: '/customform/tablemeta/save',
        type: 'post',
        data: {
            'msg': 'success',
            'code': "1",
        }
    }
}

export function gettablemetaData() {
    return {
        //isOpen: false,
        url: '/customform/tablemeta/get',
        type: 'get',
        data: {
            'msg': 'success',
            'code': "1",
            'data': {
                "createTime": "2019-08-26 15:22:00",
                "id": "bdfa8d9b63544a3eb542a2393f594604",
                "displayName": "其他交易公告信息",
                "datasetCode": "Q01",
                "sort": 18,
                "status": 0,
                "tableName": "qtjy_other_trade_pub_info",
                "uniqueNames": "其他交易公告唯一标识",
                "updateTime": "2019-09-18 16:41:59",
                "updateUser": "0"
            }
        }
    }
}

export function getscripts() {

    return {
        //isOpen: false,
        url: '/customform/tablemeta/scripts',
        type: 'post',
        data: {
            'data': {
                content: 'select * from test'
            },
            'msg': 'success',
            'code': "1",
        }
    }
}